/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new estimate.
 * @export
 * @interface CreateEstimateRequest
 */
export interface CreateEstimateRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    documentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateRequest
     */
    sourceSystem: CreateEstimateRequestSourceSystemEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateRequest
     */
    kind: CreateEstimateRequestKindEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    subtotalCents?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    taxesCents?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    depreciationCents?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateRequest
     */
    totalCents?: number;
}


/**
 * @export
 */
export const CreateEstimateRequestSourceSystemEnum = {
    Xactimate: 'xactimate',
    Symbility: 'symbility',
    Other: 'other'
} as const;
export type CreateEstimateRequestSourceSystemEnum = typeof CreateEstimateRequestSourceSystemEnum[keyof typeof CreateEstimateRequestSourceSystemEnum];

/**
 * @export
 */
export const CreateEstimateRequestKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type CreateEstimateRequestKindEnum = typeof CreateEstimateRequestKindEnum[keyof typeof CreateEstimateRequestKindEnum];


/**
 * Check if a given object implements the CreateEstimateRequest interface.
 */
export function instanceOfCreateEstimateRequest(value: object): value is CreateEstimateRequest {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('sourceSystem' in value) || value['sourceSystem'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function CreateEstimateRequestFromJSON(json: any): CreateEstimateRequest {
    return CreateEstimateRequestFromJSONTyped(json, false);
}

export function CreateEstimateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEstimateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'sourceSystem': json['sourceSystem'],
        'kind': json['kind'],
        'subtotalCents': json['subtotalCents'] == null ? undefined : json['subtotalCents'],
        'taxesCents': json['taxesCents'] == null ? undefined : json['taxesCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'totalCents': json['totalCents'] == null ? undefined : json['totalCents'],
    };
}

export function CreateEstimateRequestToJSON(json: any): CreateEstimateRequest {
    return CreateEstimateRequestToJSONTyped(json, false);
}

export function CreateEstimateRequestToJSONTyped(value?: CreateEstimateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'documentId': value['documentId'],
        'sourceSystem': value['sourceSystem'],
        'kind': value['kind'],
        'subtotalCents': value['subtotalCents'],
        'taxesCents': value['taxesCents'],
        'depreciationCents': value['depreciationCents'],
        'totalCents': value['totalCents'],
    };
}

